export enum SubmissionStatus {
  TODO = "todo",
  // Submitted, awaiting a mark — distinct from the unsubmitted "pending" draft.
  PENDING_MARKS = "pending_marks",
  MARKED = "marked",
  EXEMPTED = "exempted",
  RESUBMISSION_REQUIRED = "resubmission_required"
}

export const mapRawSubmissionStatus = (
  raw: string | null | undefined
): SubmissionStatus => {
  switch (raw?.toLowerCase()) {
    // "pending" is an unsubmitted draft, not awaiting marks.
    case "in progress":
    case "pending":
    case "to-do":
    case undefined:
      return SubmissionStatus.TODO;
    // "escalated" is reviewer-only; families see it as awaiting marking.
    case "pending marks":
    case "escalated":
      return SubmissionStatus.PENDING_MARKS;
    case "marked":
    case "approved":
      return SubmissionStatus.MARKED;
    case "exempted":
      return SubmissionStatus.EXEMPTED;
    case "resubmission required":
      return SubmissionStatus.RESUBMISSION_REQUIRED;
    // Fall back rather than crash a family view on an unknown status.
    default:
      console.warn(
        `mapRawSubmissionStatus: unrecognised status "${raw}" — defaulting to PENDING_MARKS`
      );
      return SubmissionStatus.PENDING_MARKS;
  }
};
